var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "wave",
    style: {
      transform: "rotate(180deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 85, 190, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 85, 190, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,60L60,50C120,40,240,20,360,17.5C480,15,600,30,720,52.5C840,75,960,105,1080,97.5C1200,90,1320,45,1440,37.5C1560,30,1680,60,1800,80C1920,100,2040,110,2160,97.5C2280,85,2400,50,2520,47.5C2640,45,2760,75,2880,85C3000,95,3120,85,3240,67.5C3360,50,3480,25,3600,32.5C3720,40,3840,80,3960,97.5C4080,115,4200,110,4320,90C4440,70,4560,35,4680,32.5C4800,30,4920,60,5040,80C5160,100,5280,110,5400,107.5C5520,105,5640,90,5760,70C5880,50,6000,25,6120,22.5C6240,20,6360,40,6480,42.5C6600,45,6720,30,6840,27.5C6960,25,7080,35,7200,40C7320,45,7440,45,7560,37.5C7680,30,7800,15,7920,17.5C8040,20,8160,40,8280,60C8400,80,8520,100,8580,110L8640,120L8640,150L8580,150C8520,150,8400,150,8280,150C8160,150,8040,150,7920,150C7800,150,7680,150,7560,150C7440,150,7320,150,7200,150C7080,150,6960,150,6840,150C6720,150,6600,150,6480,150C6360,150,6240,150,6120,150C6000,150,5880,150,5760,150C5640,150,5520,150,5400,150C5280,150,5160,150,5040,150C4920,150,4800,150,4680,150C4560,150,4440,150,4320,150C4200,150,4080,150,3960,150C3840,150,3720,150,3600,150C3480,150,3360,150,3240,150C3120,150,3000,150,2880,150C2760,150,2640,150,2520,150C2400,150,2280,150,2160,150C2040,150,1920,150,1800,150C1680,150,1560,150,1440,150C1320,150,1200,150,1080,150C960,150,840,150,720,150C600,150,480,150,360,150C240,150,120,150,60,150L0,150Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.28f648d0670acf9abda0c1f3a5b31c5a.svg";
export { ForwardRef as ReactComponent };